import React, { useState } from "react";

export default function GeneralMainMenu(props) {
    const [activeTab, setActiveTab] = useState(props.menuList.length > 0 ? props.menuList[0]?.menu_id : null);

    const handleTabClick = (menuId) => {
        setActiveTab(menuId);
        // Show corresponding sub-menu
        const subMenuElement = document.querySelector(`[data-menu-id="${menuId}"]`);
        if (subMenuElement) {
            // Hide all sub-menus
            document.querySelectorAll('[data-menu-id]').forEach(el => {
                el.classList.add('hidden');
                el.classList.remove('block');
            });
            // Show selected sub-menu
            subMenuElement.classList.remove('hidden');
            subMenuElement.classList.add('block');
        }
    };

    return (
        <div className="flex items-end overflow-x-auto" id="kt_brand_tabs">
            <div className="flex overflow-x-auto px-2 lg:ml-6 lg:mb-0" id="kt_header_tabs">
                <nav className="flex flex-nowrap whitespace-nowrap gap-1" role="tablist">
                    {props.menuList.length > 0 &&
                        props.menuList.map((menu, i) => {
                            const isActive = activeTab === menu.menu_id;
                            return (
                                            <button
                                                key={i}
                                                onClick={() => handleTabClick(menu.menu_id)}
                                                className={[
                                                    "rounded-t-lg border-b-2 px-3 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition-all duration-200 whitespace-nowrap",
                                                    isActive
                                                        ? "border-white text-white shadow-sm"
                                                        : "border-transparent text-white/80 hover:border-white/50 hover:text-white",
                                                ].join(" ")}
                                                role="tab"
                                                aria-selected={isActive}
                                            >
                                                {menu.menu_name}
                                            </button>
                            );
                        })
                    }
                </nav>
            </div>
        </div>
    )
};